import {computed, Injectable, signal} from '@angular/core';
import {EDITOR_TYPOLOGY_LABEL} from '@modules/activity-edition/core/features/constants/editor-typology-label';

@Injectable({
    providedIn: 'root',
})
export class ActivityEditionConfigurationService {

    public readonly allowedTypologies = signal([
        EDITOR_TYPOLOGY_LABEL.multipleChoiceUniqueAnswer,
        EDITOR_TYPOLOGY_LABEL.multipleChoice,
        EDITOR_TYPOLOGY_LABEL.trueFalse,
        EDITOR_TYPOLOGY_LABEL.sortMat,
        EDITOR_TYPOLOGY_LABEL.textMatching,
        EDITOR_TYPOLOGY_LABEL.shortAnswer,
        EDITOR_TYPOLOGY_LABEL.fillBlanks,
        EDITOR_TYPOLOGY_LABEL.missing,
        // EDITOR_TYPOLOGY_LABEL.pointImage
        EDITOR_TYPOLOGY_LABEL.multimedia,
        EDITOR_TYPOLOGY_LABEL.twoMedia,
        // EDITOR_TYPOLOGY_LABEL.awareness,
        EDITOR_TYPOLOGY_LABEL.recording,
        // EDITOR_TYPOLOGY_LABEL.memory
        EDITOR_TYPOLOGY_LABEL.shortAnswerButLong,
        EDITOR_TYPOLOGY_LABEL.external
    ]);

    public readonly disallowedTypologies = computed(() => {
        return Object.values(EDITOR_TYPOLOGY_LABEL).filter(typology => !this.allowedTypologies().includes(typology));
    })

    public allowTypology(typology: EDITOR_TYPOLOGY_LABEL): void {
        if (!this.allowedTypologies().includes(typology)) {
            this.allowedTypologies.update((current) => [...current, typology]);
        } else {
            console.warn(`Typology ${typology} is already allowed.`);
        }
    }

    public disallowTypology(typology: EDITOR_TYPOLOGY_LABEL): void {
        if (this.allowedTypologies().includes(typology)) {
            this.allowedTypologies.update((current) => current.filter(t => t !== typology));
        } else {
            console.warn(`Typology ${typology} is not currently allowed.`);
        }
    }
}
